import { List, Create, Edit, View, Receive } from "../Components/index.js";

export default [
    {
        path: "/voucher/account/purchase",
        component: List,
        name: "account.voucher.purchase",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/purchase/receive",
        component: Receive,
        name: "account.voucher.purchase.receive",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/purchase/create",
        component: Create,
        name: "account.voucher.purchase.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/purchase/:id/edit",
        component: Edit,
        name: "account.voucher.purchase.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/purchase/:id/view",
        component: View,
        name: "account.voucher.purchase.view",
        meta: {
            requiresAuth: true,
        },
    },
];
